const organization = {
    require_membership: '使用者必須是該組織的成員才能繼續。',
};
export default Object.freeze(organization);
